import React from 'react';

/* AR / Collections' KPI row (quiet ledger, matches Job Costs / Workload): Outstanding and Cash
   Received, and Billing by Phase (2026-10-19, Duncan: "match the modern and nice look of something
   like the job cost tab"). ARPage's style block turns it into separate tiles on narrow screens
   (.akr / .akr-tile / .akr-div). */

/* flex-basis 176 (was 200) and 14px sides (was 20). Six tiles at a 200px basis plus
   five hairline dividers plus the section's padding is a 1221px hypothetical against
   the 1204px of content a 1512px laptop gives -- seventeen pixels short, so the sixth
   tile wrapped and then stretched to 1186px to hold "35d". That cost 110px of height
   for one number. 176 fits six across down to 1077px of content (~1377px viewport).
   The narrower padding is not cosmetic: at 20px sides the tiles resolve to 157px of
   inner width, and "$40,323,445.32" needs 162px at valueSize 20 -- with
   overflowWrap:'anywhere' on the value that does not overflow, it WRAPS, splitting a
   money figure across lines as "$40,323,445.3 / 2". 14px sides give 169px and it
   stays whole. Type sizes are untouched. */
const KpiTile = ({ label, value, sub, valueColor, muted, valueSize = 27 }) => (
  <div className="akr-tile" style={{ display: 'flex', flexDirection: 'column', gap: 9, flex: '1 1 176px', minWidth: 170, padding: '12px 14px' }}>
    <div style={{ fontSize: 11.5, fontWeight: 700, letterSpacing: '0.075em', textTransform: 'uppercase', color: 'var(--text-3)' }}>{label}</div>
    <div className="mono" style={{ fontSize: valueSize, fontWeight: 800, lineHeight: 1.08, letterSpacing: '-0.03em', fontVariantNumeric: 'tabular-nums', minWidth: 0, overflowWrap: 'anywhere', color: muted ? 'var(--text-4)' : (valueColor || 'var(--text-1)') }}>{value}</div>
    <div className="mono" style={{ marginTop: 'auto', minHeight: 16, fontSize: 12, lineHeight: 1.35, color: 'var(--text-3)', fontVariantNumeric: 'tabular-nums' }}>{sub || ' '}</div>
  </div>
);

const KpiDivider = () => <div className="akr-div" aria-hidden="true" style={{ width: 1, alignSelf: 'stretch', background: 'var(--border-subtle)', margin: '14px 0', flex: '0 0 auto' }} />;

const KpiRow = ({ tiles, label = 'Accounts receivable totals' }) => (
  <section className="akr" role="group" aria-label={label} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'stretch', gap: 0, padding: '4px 8px', background: 'var(--bg-surface)', border: '1px solid var(--border-default)', borderRadius: 12, boxShadow: 'var(--shadow-sm)' }}>
    {tiles.map((t, i) => (
      <React.Fragment key={t.label}>
        {i > 0 && <KpiDivider />}
        <KpiTile {...t} />
      </React.Fragment>
    ))}
  </section>
);

export default KpiRow;
